// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__ynh68","default":"Button_default__zpIOI"};